export enum Languages {
  ru = 'ru',
  en = 'en',
}
